import { customModalInterestitalStyles,
    Block,
    InterstitialPopupBlockConstants,
    CampaignIframeOverlayConstants
   } from './exportComponent';   

const ContentProperty = (entity) => {
    
    const block = new Block(entity);
    const anchorId = block.getFieldValue(InterstitialPopupBlockConstants.anchorId);
    const textImage = block.getFieldValue(InterstitialPopupBlockConstants.textImage);
    const title = block.getFieldValue(InterstitialPopupBlockConstants.title);
    const body = block.getFieldValue(InterstitialPopupBlockConstants.body);
    const formLabels = block.getFieldValue(InterstitialPopupBlockConstants.formLabels);
    const ctaLabel = block.getFieldValue(InterstitialPopupBlockConstants.callToActionLabel);
    const cancelCtaLabel = block.getFieldValue(InterstitialPopupBlockConstants.cancelCallToActionLabel);
    const legalTextTitle = block.getFieldValue(InterstitialPopupBlockConstants.legalTextTitle);
    const legalText = block.getFieldValue(InterstitialPopupBlockConstants.legalText);
    const legalTextWithoutCheckbox = block.getFieldValue(InterstitialPopupBlockConstants.legalTextWithoutCheckbox);
    const backgroundAsset = block.getFieldValue(InterstitialPopupBlockConstants.backgroundAsset);
    const mobileBackgroundAsset = block.getFieldValue(InterstitialPopupBlockConstants.mobileBackgroundAsset);
    const interstitialButtonImage = block.getFieldValue(InterstitialPopupBlockConstants.interstitialButtonImage);

    const backgroundColor = block.getFieldValue(InterstitialPopupBlockConstants.backgroundColor);
    const closeModalLabel = block.getFieldValue(InterstitialPopupBlockConstants.closeModalLabel);
    const defaultAbTestValue = block.getFieldValue(InterstitialPopupBlockConstants.defaultAbTestValue);
    const expiryHours = block.getFieldValue(CampaignIframeOverlayConstants.expiryHours);
    const registerFailedError = block.getFieldValue(InterstitialPopupBlockConstants.registerFailedError);
    const emailExceedLimitLabel = block.getFieldValue(InterstitialPopupBlockConstants.emailLimitExceedLabel);

    const surveyTitle = block.getFieldValue(InterstitialPopupBlockConstants.surveyTitle);
    const surveyDescription = block.getFieldValue(InterstitialPopupBlockConstants.surveyDescription);
    const surveyDisclaimer = block.getFieldValue(InterstitialPopupBlockConstants.surveyDisclaimer);
    const rawTopicList = block.getFieldValue(InterstitialPopupBlockConstants.topicList);
    const screen2BackgroundAsset = block.getFieldValue(InterstitialPopupBlockConstants.backgroundAssetScrondScreen);
    const screen2MobileBackgroundAsset = block.getFieldValue(InterstitialPopupBlockConstants.mobileBackgroundAssetSecondScreen);
    const screen2SubmitCtaText = block.getFieldValue(CampaignIframeOverlayConstants.screen2SubmitCtaText);
    const noticeTitleFirst =  block.getFieldValue(InterstitialPopupBlockConstants.noticeTitleFirst);
    const thankYouTitleLabel = block.getFieldValue(InterstitialPopupBlockConstants.thankYouTitleLabel);
    const thankYouDescriptionLabel = block.getFieldValue(InterstitialPopupBlockConstants.thankYouDescriptionLabel);
    const thankYouBackgroundAsset = block.getFieldValue(InterstitialPopupBlockConstants.thankYouBackgroundAsset);
    const thankyouMobileBackgroundAsset = block.getFieldValue(InterstitialPopupBlockConstants.thankYouMobileBackgroundAsset);
    const logoImage2 = block.getFieldValue(InterstitialPopupBlockConstants.logoImage2);
    const modalLabelFirst = block.getFieldValue(InterstitialPopupBlockConstants.modalLabelFirst);
    const modalLabelSecond = block.getFieldValue(InterstitialPopupBlockConstants.modalLabelSecond);
    
    const className = block.getFieldValue(InterstitialPopupBlockConstants.className);
    const thankYouDescription = block.getFieldValue(InterstitialPopupBlockConstants.thankYouDescription);
        
    return {
        anchorId,
        textImage,
        title,
        body,
        formLabels,
        ctaLabel,
        cancelCtaLabel,
        legalTextTitle,
        legalText,
        legalTextWithoutCheckbox,
        backgroundAsset,
        mobileBackgroundAsset,
        interstitialButtonImage,
        backgroundColor,
        closeModalLabel,
        defaultAbTestValue,
        expiryHours,
        registerFailedError,
        emailExceedLimitLabel,
        surveyTitle,
        surveyDescription,
        surveyDisclaimer,
        rawTopicList,
        screen2BackgroundAsset,
        screen2MobileBackgroundAsset,
        screen2SubmitCtaText,
        thankYouTitleLabel,
        thankYouDescriptionLabel,
        thankYouBackgroundAsset,
        thankyouMobileBackgroundAsset,
        modalLabelFirst,
        modalLabelSecond,
        className,
        thankYouDescription,
        logoImage2,
        noticeTitleFirst
    }
}

export default ContentProperty;